import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-black.png'


const _withScopeId = n => (_pushScopeId("data-v-3f5d42c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "row w-100 d-flex justify-content-center align-items-center mb-1 mt-1" }
const _hoisted_4 = { class: "col-md-12 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "store",
  style: {"width":"120px"}
}, null, -1))
const _hoisted_6 = { class: "sidebar-body" }
const _hoisted_7 = {
  class: "nav mb-5",
  style: {"padding-bottom":"45px !important"}
}
const _hoisted_8 = {
  key: 0,
  class: "nav-item fixed-scanner"
}
const _hoisted_9 = { class: "link-title" }
const _hoisted_10 = {
  key: 2,
  class: "nav-item mb-2"
}
const _hoisted_11 = { class: "link-title" }
const _hoisted_12 = {
  key: 3,
  class: "nav-item mb-2"
}
const _hoisted_13 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#prospects-collapse",
  "aria-expanded": "false"
}
const _hoisted_14 = { class: "link-title" }
const _hoisted_15 = {
  class: "collapse",
  id: "prospects-collapse"
}
const _hoisted_16 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_17 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_18 = { class: "link-title" }
const _hoisted_19 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_20 = { class: "link-title" }
const _hoisted_21 = {
  key: 4,
  class: "nav-item mb-2"
}
const _hoisted_22 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#members-collapse",
  "aria-expanded": "false"
}
const _hoisted_23 = { class: "link-title" }
const _hoisted_24 = {
  class: "collapse",
  id: "members-collapse"
}
const _hoisted_25 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_26 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_27 = { class: "link-title" }
const _hoisted_28 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_29 = { class: "link-title" }
const _hoisted_30 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_31 = { class: "link-title" }
const _hoisted_32 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_33 = { class: "link-title" }
const _hoisted_34 = {
  key: 5,
  class: "nav-item mb-2"
}
const _hoisted_35 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#subscriptionsmembers-collapse",
  "aria-expanded": "false"
}
const _hoisted_36 = { class: "link-title" }
const _hoisted_37 = {
  class: "collapse",
  id: "subscriptionsmembers-collapse"
}
const _hoisted_38 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_39 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_40 = { class: "link-title" }
const _hoisted_41 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_42 = { class: "link-title" }
const _hoisted_43 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_44 = { class: "link-title" }
const _hoisted_45 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_46 = { class: "link-title" }
const _hoisted_47 = {
  key: 4,
  class: "nav-item nav-item-ml"
}
const _hoisted_48 = { class: "link-title" }
const _hoisted_49 = {
  key: 5,
  class: "nav-item nav-item-ml"
}
const _hoisted_50 = { class: "link-title" }
const _hoisted_51 = {
  key: 6,
  class: "nav-item nav-item-ml"
}
const _hoisted_52 = { class: "link-title" }
const _hoisted_53 = {
  key: 6,
  class: "nav-item mb-2"
}
const _hoisted_54 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainers-collapse",
  "aria-expanded": "false"
}
const _hoisted_55 = { class: "link-title" }
const _hoisted_56 = {
  class: "collapse",
  id: "trainers-collapse"
}
const _hoisted_57 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_58 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_59 = { class: "link-title" }
const _hoisted_60 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_61 = { class: "link-title" }
const _hoisted_62 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-title" }, " Calendra ", -1))
const _hoisted_64 = {
  key: 7,
  class: "nav-item mb-2"
}
const _hoisted_65 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#incomes-collapse",
  "aria-expanded": "false"
}
const _hoisted_66 = { class: "link-title" }
const _hoisted_67 = {
  class: "collapse",
  id: "incomes-collapse"
}
const _hoisted_68 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_69 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_70 = { class: "link-title" }
const _hoisted_71 = {
  key: 8,
  class: "nav-item mb-2"
}
const _hoisted_72 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#expenses-collapse",
  "aria-expanded": "false"
}
const _hoisted_73 = { class: "link-title" }
const _hoisted_74 = {
  class: "collapse",
  id: "expenses-collapse"
}
const _hoisted_75 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_76 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_77 = { class: "link-title" }
const _hoisted_78 = {
  key: 9,
  class: "nav-item mb-2"
}
const _hoisted_79 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#stock-collapse",
  "aria-expanded": "false"
}
const _hoisted_80 = { class: "link-title" }
const _hoisted_81 = {
  class: "collapse",
  id: "stock-collapse"
}
const _hoisted_82 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_83 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_84 = { class: "link-title" }
const _hoisted_85 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_86 = { class: "link-title" }
const _hoisted_87 = {
  key: 10,
  class: "nav-item mb-2"
}
const _hoisted_88 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#orders-collapse",
  "aria-expanded": "false"
}
const _hoisted_89 = { class: "link-title" }
const _hoisted_90 = {
  class: "collapse",
  id: "orders-collapse"
}
const _hoisted_91 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_92 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_93 = { class: "link-title" }
const _hoisted_94 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_95 = { class: "link-title" }
const _hoisted_96 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_97 = { class: "link-title" }
const _hoisted_98 = {
  key: 11,
  class: "nav-item mb-2"
}
const _hoisted_99 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#regulations-collapse",
  "aria-expanded": "false"
}
const _hoisted_100 = { class: "link-title" }
const _hoisted_101 = {
  class: "collapse",
  id: "regulations-collapse"
}
const _hoisted_102 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_103 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_104 = { class: "link-title" }
const _hoisted_105 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_106 = { class: "link-title" }
const _hoisted_107 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_108 = { class: "link-title" }
const _hoisted_109 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_110 = { class: "link-title" }
const _hoisted_111 = {
  key: 12,
  class: "nav-item mb-2"
}
const _hoisted_112 = { class: "link-title" }
const _hoisted_113 = {
  key: 13,
  class: "nav-item mb-2"
}
const _hoisted_114 = { class: "link-title" }
const _hoisted_115 = {
  key: 14,
  class: "nav-item mb-2"
}
const _hoisted_116 = { class: "link-title" }
const _hoisted_117 = {
  key: 15,
  class: "nav-item mb-2"
}
const _hoisted_118 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#messages-collapse",
  "aria-expanded": "false"
}
const _hoisted_119 = { class: "link-title" }
const _hoisted_120 = {
  class: "collapse",
  id: "messages-collapse"
}
const _hoisted_121 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_122 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-title" }, " Whatsapp", -1))
const _hoisted_124 = {
  key: 16,
  class: "nav-item mb-2"
}
const _hoisted_125 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#presences-collapse",
  "aria-expanded": "false"
}
const _hoisted_126 = { class: "link-title" }
const _hoisted_127 = {
  class: "collapse",
  id: "presences-collapse"
}
const _hoisted_128 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_129 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_130 = { class: "link-title" }
const _hoisted_131 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_132 = { class: "link-title" }
const _hoisted_133 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_134 = { class: "link-title" }
const _hoisted_135 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_136 = { class: "link-title" }
const _hoisted_137 = {
  key: 17,
  class: "nav-item mb-2"
}
const _hoisted_138 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#settings-collapse",
  "aria-expanded": "false"
}
const _hoisted_139 = { class: "link-title" }
const _hoisted_140 = {
  class: "collapse",
  id: "settings-collapse"
}
const _hoisted_141 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_142 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_143 = { class: "link-title" }
const _hoisted_144 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_145 = { class: "link-title" }
const _hoisted_146 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_147 = { class: "link-title" }
const _hoisted_148 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_149 = { class: "link-title" }
const _hoisted_150 = {
  key: 4,
  class: "nav-item nav-item-ml"
}
const _hoisted_151 = { class: "link-title" }
const _hoisted_152 = {
  key: 5,
  class: "nav-item nav-item-ml"
}
const _hoisted_153 = { class: "link-title" }
const _hoisted_154 = {
  key: 6,
  class: "nav-item nav-item-ml"
}
const _hoisted_155 = { class: "link-title" }
const _hoisted_156 = {
  key: 7,
  class: "nav-item nav-item-ml"
}
const _hoisted_157 = { class: "link-title" }
const _hoisted_158 = {
  key: 8,
  class: "nav-item nav-item-ml"
}
const _hoisted_159 = { class: "link-title" }
const _hoisted_160 = {
  key: 9,
  class: "nav-item nav-item-ml"
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-title" }, " Lier votre compte WhatsApp", -1))
const _hoisted_162 = {
  key: 10,
  class: "nav-item nav-item-ml"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-title" }, " Paramètres", -1))
const _hoisted_164 = {
  key: 18,
  class: "nav-item mb-2"
}
const _hoisted_165 = {
  class: "nav-link nav-category align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#pointeuseISAPI-collapse",
  "aria-expanded": "false"
}
const _hoisted_166 = { class: "link-title" }
const _hoisted_167 = {
  class: "collapse",
  id: "pointeuseISAPI-collapse"
}
const _hoisted_168 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_169 = {
  key: 0,
  class: "nav-item nav-item-ml"
}
const _hoisted_170 = { class: "link-title" }
const _hoisted_171 = {
  key: 1,
  class: "nav-item nav-item-ml"
}
const _hoisted_172 = { class: "link-title" }
const _hoisted_173 = {
  key: 2,
  class: "nav-item nav-item-ml"
}
const _hoisted_174 = { class: "link-title" }
const _hoisted_175 = {
  key: 3,
  class: "nav-item nav-item-ml"
}
const _hoisted_176 = { class: "link-title" }
const _hoisted_177 = {
  key: 4,
  class: "nav-item nav-item-ml"
}
const _hoisted_178 = { class: "link-title" }
const _hoisted_179 = {
  key: 5,
  class: "nav-item nav-item-ml"
}
const _hoisted_180 = { class: "link-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_scanner_qr_code = _resolveComponent("scanner-qr-code")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.userUUID && _ctx.clubUUID)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'dashboard', params: { clubUUID: _ctx.clubUUID } },
                class: "bg-none"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.user?.firstName || '') + " " + _toDisplayString(_ctx.user?.lastName || ''), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (_ctx.hasPermission('scan_qr_code'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createVNode(_component_scanner_qr_code)
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('acces_rapide'))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass(["nav-item mb-2", { 'margin-top-109': _ctx.hasPermission('scan_qr_code') }])
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'access-rapide', params: { clubUUID: _ctx.clubUUID } },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "jet-fighter-up",
                        size: "lg",
                        class: "link-icon"
                      }),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.i18n.t('layout.sidbar.accesRapid')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('dashboard'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: { name: 'dashboard', params: { clubUUID: _ctx.clubUUID } },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "dashboard",
                        size: "lg",
                        class: "link-icon"
                      }),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.i18n.t('layout.sidbar.dashboard')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('prospection_view') || _ctx.hasPermission('prospection_view'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "users",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.members.prospects')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("ul", _hoisted_16, [
                      (_ctx.hasPermission('prospection_create'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            _createVNode(_component_router_link, {
                              to: { name: 'create-prospection', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "user-plus",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.new_prospect')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('prospection_view'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createVNode(_component_router_link, {
                              to: { name: 'prospection', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.prospection_list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('members'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                  _createElementVNode("a", _hoisted_22, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "users",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_23, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.members.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("ul", _hoisted_25, [
                      (_ctx.hasPermission('new_subscriptions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _createVNode(_component_router_link, {
                              to: { name: 'inscription', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "user-plus",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.new_subscriptions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('members_list'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                            _createVNode(_component_router_link, {
                              to: { name: 'members', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.members_list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('members_list'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              to: { name: 'assurances-members', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.etat_assurances')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('members_with_pointeuses_errors'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                            _createVNode(_component_router_link, {
                              to: { name: 'members-with-pointeuses-errors', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.members_with_issues_pointeuses')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('subscriptions_members'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                  _createElementVNode("a", _hoisted_35, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "check",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_36, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("ul", _hoisted_38, [
                      (_ctx.hasPermission('active_subscriptions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                            _createVNode(_component_router_link, {
                              to: { name: 'active-subscriptions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "hourglass-start",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.active_subscriptions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('expired_subscriptions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                            _createVNode(_component_router_link, {
                              to: { name: 'expired-subscriptions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "hourglass-end",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.expired_subscriptions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('subscriptions_expiring'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                            _createVNode(_component_router_link, {
                              to: { name: 'subscriptions-expiring', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "hourglass-half",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.subscriptions_expiring')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('historiques_subscriptions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                            _createVNode(_component_router_link, {
                              to: { name: 'historiques-subscriptions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "history",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.historiques_subscriptions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('credits'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                            _createVNode(_component_router_link, {
                              to: { name: 'credits', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "hand-holding-dollar",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.credits')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('renewal_status'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                            _createVNode(_component_router_link, {
                              to: { name: 'members-renewed-status', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.i18n.t('layout.sidbar.members.renewal_status')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('subscriptions_sold'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                            _createVNode(_component_router_link, {
                              to: { name: 'packs-sales', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "chart-bar",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.subscriptions_sold')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('trainers') || _ctx.hasPermission('trainers_stats') || _ctx.hasPermission('planned_sessions') || _ctx.hasPermission('schedules_session'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                  _createElementVNode("a", _hoisted_54, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "users",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_55, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.trainers.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("ul", _hoisted_57, [
                      (_ctx.hasPermission('trainers'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_58, [
                            _createVNode(_component_router_link, {
                              to: { name: 'trainers', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "users",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.i18n.t('layout.sidbar.trainers.trainers_list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('planned_sessions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_60, [
                            _createVNode(_component_router_link, {
                              to: { name: 'public-sessions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "calendar-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.i18n.t('layout.sidbar.trainers.session')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('schedules_session'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                            _createVNode(_component_router_link, {
                              to: { name: 'schedules', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "calendar-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _hoisted_63
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('incomes_list'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_64, [
                  _createElementVNode("a", _hoisted_65, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "coins",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_66, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.incomes.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("ul", _hoisted_68, [
                      (_ctx.hasPermission('incomes_list'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                            _createVNode(_component_router_link, {
                              to: { name: 'incomes', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "store",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.i18n.t('layout.sidbar.incomes.list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('expenses_list'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                  _createElementVNode("a", _hoisted_72, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "coins",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_73, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.expenses.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("ul", _hoisted_75, [
                      (_ctx.hasPermission('expenses_list'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_76, [
                            _createVNode(_component_router_link, {
                              to: { name: 'expenses', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "store",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.i18n.t('layout.sidbar.expenses.list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('view_stock_products') || _ctx.hasPermission('view_stock_categories'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_78, [
                  _createElementVNode("a", _hoisted_79, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "store-alt",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_80, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.stock.product.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("ul", _hoisted_82, [
                      (_ctx.hasPermission('view_stock_categories'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                            _createVNode(_component_router_link, {
                              to: { name: 'list-categories', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "tags",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.i18n.t('layout.sidbar.stock.product.categories')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('view_stock_products'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_85, [
                            _createVNode(_component_router_link, {
                              to: { name: 'list-products', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "box",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.i18n.t('layout.sidbar.stock.product.products')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('view_stock_orders'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_87, [
                  _createElementVNode("a", _hoisted_88, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "store-alt",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_89, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.stock.order.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("ul", _hoisted_91, [
                      (_ctx.hasPermission('view_stock_orders'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                            _createVNode(_component_router_link, {
                              to: { name: 'orders', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "receipt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.i18n.t('layout.sidbar.stock.order.liste')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('create_stock_orders'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_94, [
                            _createVNode(_component_router_link, {
                              to: { name: 'stock-add-order', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "cart-plus",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.i18n.t('layout.sidbar.stock.order.add_order_product')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('create_stock_orders'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_96, [
                            _createVNode(_component_router_link, {
                              to: { name: 'stock-add-order-spa', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "spa",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.i18n.t('layout.sidbar.stock.order.add_order_service')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('regulations'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                  _createElementVNode("a", _hoisted_99, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "money-check-dollar",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_100, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("ul", _hoisted_102, [
                      (_ctx.hasPermission('transactions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                            _createVNode(_component_router_link, {
                              to: { name: 'encaissements', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "file-invoice",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.encaissements')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('payments_stats'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                            _createVNode(_component_router_link, {
                              to: { name: 'reporting-cashflow-incomes', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "money-bill-trend-up",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.cashflow_encaissements')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('transactions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_107, [
                            _createVNode(_component_router_link, {
                              to: { name: 'decaissements', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "file-invoice",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.decaissements')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('payments_stats'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_109, [
                            _createVNode(_component_router_link, {
                              to: { name: 'reporting-cashflow-expenses', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "money-bill-trend-up",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.cashflow_decaissements')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('ca'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_111, [
                  _createVNode(_component_router_link, {
                    to: { name: 'global-revenu', params: { clubUUID: _ctx.clubUUID } },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chart-pie",
                        size: "lg",
                        class: "link-icon"
                      }),
                      _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.i18n.t('layout.sidbar.subscriptions.ca')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('reporting'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_113, [
                  _createVNode(_component_router_link, {
                    to: { name: 'reporting', params: { clubUUID: _ctx.clubUUID } },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chart-pie",
                        size: "lg",
                        class: "link-icon"
                      }),
                      _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.i18n.t('layout.sidbar.reporting.title')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('business_insights'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_115, [
                  _createVNode(_component_router_link, {
                    to: { name: 'business-insights', params: { clubUUID: _ctx.clubUUID } },
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chart-line",
                        size: "lg",
                        class: "link-icon"
                      }),
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.i18n.t('layout.sidbar.regulations.business_insights')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('sendmail') || _ctx.hasPermission('whatssap_evolution'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_117, [
                  _createElementVNode("a", _hoisted_118, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "paper-plane",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_119, [
                      _createTextVNode("Gestion de la messagerie "),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("ul", _hoisted_121, [
                      (_ctx.hasPermission('whatssap_evolution'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_122, [
                            _createVNode(_component_router_link, {
                              to: { name: 'send-whatsapp', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "comment-dots",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _hoisted_123
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('presences_today') || _ctx.hasPermission('history_presences'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_124, [
                  _createElementVNode("a", _hoisted_125, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "clock",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_126, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.presences.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("ul", _hoisted_128, [
                      (_ctx.hasPermission('presences_today'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_129, [
                            _createVNode(_component_router_link, {
                              to: { name: 'presences', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "sign-in-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.i18n.t('layout.sidbar.presences.today')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('history_presences'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_131, [
                            _createVNode(_component_router_link, {
                              to: { name: 'hitoriques-presences', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "history",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.i18n.t('layout.sidbar.presences.history_presences')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('members_checkins'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_133, [
                            _createVNode(_component_router_link, {
                              to: { name: 'members-checkins', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "user-clock",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.i18n.t('layout.sidbar.presences.checkins')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('daily_attendance'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_135, [
                            _createVNode(_component_router_link, {
                              to: { name: 'daily-member-activity', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fire",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.i18n.t('layout.sidbar.presences.daily_attendance')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('settings'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_137, [
                  _createElementVNode("a", _hoisted_138, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "gears",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_139, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.settings.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("ul", _hoisted_141, [
                      (_ctx.hasPermission('subscriptions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_142, [
                            _createVNode(_component_router_link, {
                              to: { name: 'subscriptions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "shapes",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.subscriptions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('packs'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_144, [
                            _createVNode(_component_router_link, {
                              to: { name: 'packs', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "trophy",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_145, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.packs')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('fees'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_146, [
                            _createVNode(_component_router_link, {
                              to: { name: 'fees', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "money-bill",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.fees')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('assurances'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_148, [
                            _createVNode(_component_router_link, {
                              to: { name: 'assurances', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "briefcase-medical",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.assurances')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('promotions'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_150, [
                            _createVNode(_component_router_link, {
                              to: { name: 'promotions', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "gift",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.promotions')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('incomes'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_152, [
                            _createVNode(_component_router_link, {
                              to: { name: 'incomes-categories-services', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "store-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.incomes')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('expenses'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_154, [
                            _createVNode(_component_router_link, {
                              to: { name: 'expenses-categories-services', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "store-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.expenses')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('announcements'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_156, [
                            _createVNode(_component_router_link, {
                              to: { name: 'announcements', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "tv",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_157, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.announcements')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('cash_journals'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_158, [
                            _createVNode(_component_router_link, {
                              to: { name: 'cash-journals', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "sack-dollar",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.i18n.t('layout.sidbar.settings.cash_journals')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('connect_whatsapp'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_160, [
                            _createVNode(_component_router_link, {
                              to: { name: 'whatsapp-connect', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "envelope",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _hoisted_161
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('settings_club'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_162, [
                            _createVNode(_component_router_link, {
                              to: { name: 'settings-club', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "gear",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _hoisted_163
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasPermission('manage_hikvision_pointeuses'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_164, [
                  _createElementVNode("a", _hoisted_165, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "tablet-alt",
                      size: "lg",
                      class: "link-icon"
                    }),
                    _createElementVNode("span", _hoisted_166, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.title')) + " ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: "chevron-right",
                        size: "sm",
                        class: "link-icon-arrow"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("ul", _hoisted_168, [
                      (_ctx.hasPermission('pointeuses'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_169, [
                            _createVNode(_component_router_link, {
                              to: { name: 'pointeuses', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fingerprint",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_170, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.list')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('config_schedules_templates_shift'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_171, [
                            _createVNode(_component_router_link, {
                              to: { name: 'schedules-templates', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "calendar",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.schedules_templates')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('config_schedules_templates_shift'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_173, [
                            _createVNode(_component_router_link, {
                              to: { name: 'add-schedules-templates', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "calendar-plus",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_174, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.add_schedule_template')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('manage_push_to_pointeuses'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_175, [
                            _createVNode(_component_router_link, {
                              to: { name: 'add-person-to-pointeuses', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "tablet-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.manage_push_to_pointeuses')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('manage_remove_from_pointeuses'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_177, [
                            _createVNode(_component_router_link, {
                              to: { name: 'delete-person-from-pointeuses', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "tablet-alt",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.manage_remove_from_pointeuses')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('test_connection_raspberry'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_179, [
                            _createVNode(_component_router_link, {
                              to: { name: 'test-connection', params: { clubUUID: _ctx.clubUUID } },
                              class: "nav-link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "microchip",
                                  size: "lg",
                                  class: "link-icon"
                                }),
                                _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.i18n.t('layout.sidbar.pointeuses.test_connection_raspberry')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}